import {
  type AccessorFn,
  createColumnHelper as reactTableCreateColumnHelper,
  type DeepKeys,
  type DeepValue,
  type DisplayColumnDef,
  type IdentifiedColumnDef,
  type RowData,
} from "@tanstack/react-table";

import { type ExtendedColumnDef } from "./table";

export const createColumnHelper = <TData extends RowData>() => {
  const columnHelper = reactTableCreateColumnHelper<TData>();

  return {
    ...columnHelper,
    accessor: <
      // NOTE: this is copied straight out of the react-table accessor function,
      // this is necessary because otherwise typescript looks an understanding of TValue
      TAccessor extends AccessorFn<TData> | DeepKeys<TData>,
      TValue extends TAccessor extends AccessorFn<TData, infer TReturn>
        ? TReturn
        : TAccessor extends DeepKeys<TData>
        ? DeepValue<TData, TAccessor>
        : never,
    >({
      accessorKey,
      columnDef,
    }: {
      // NOTE: this is copied straight out of the react-table accessor function,
      // this is necessary because otherwise typescript looks an understanding of TValue
      accessorKey: TAccessor;
      columnDef: (TAccessor extends AccessorFn<TData>
        ? DisplayColumnDef<TData, TValue>
        : IdentifiedColumnDef<TData, TValue>) & {
        sticky?: boolean;
      };
    }) => {
      return {
        ...columnHelper.accessor(accessorKey, columnDef),
        sticky: columnDef.sticky,
      } as ExtendedColumnDef<TData>;
    },
  };
};
